export default __webpack_public_path__ + "static/media/YELP_API.b340f30a.png";